export interface MapMarker {
  id: string;
  lat: number;
  lng: number;
  label?: string;
  status?: string;
  selected?: boolean;
}

export interface MapRoutePoint {
  lat: number;
  lng: number;
}

/** Geographic centre of India — default GPS view. */
export const INDIA_CENTER: [number, number] = [21.1466, 79.0882];
export const INDIA_ZOOM = 5;

export function hasCoordinates(lat?: number, lng?: number) {
  return lat != null && lng != null && Number.isFinite(lat) && Number.isFinite(lng)
    && !(lat === 0 && lng === 0);
}

export function statusColor(status?: string) {
  switch (status) {
    case 'moving': return '#22c55e';
    case 'stopped': return '#f59e0b';
    case 'idle': return '#8b5cf6';
    default: return '#94a3b8';
  }
}

export function getGoogleMapsApiKey() {
  return (process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '').trim();
}
